module.exports = __webpack_public_path__ + "2acb60f2/img/upload-icon.9179ae4e.svg";